import clsx from 'clsx';
import React from 'react';

const BusinessGrowthSection: React.FC = () => {
  return (
    <div className={clsx('tw-bg-white', 'tw-py-12', 'lg:tw-py-24')}>
      <div className={clsx('tw-container', 'tw-mx-auto', 'tw-px-4', 'lg:tw-px-8', 'tw-relative')}>
        <div
          className={clsx(
            'tw-rounded-3xl',
            'tw-bg-blue-50/50',
            'lg:tw-bg-blue-50',
            'tw-flex',
            'tw-flex-col',
            'lg:tw-flex-row',
            'tw-items-center',
            'tw-justify-between',
            'tw-p-16',
            'lg:tw-p-16',
            'tw-relative', // Make this relative for absolute positioning of the image
            'tw-rounded-[20px]',
            'gradient-box'
          )}
        >
          <div className={clsx('lg:tw-w-3/5', 'tw-text-center', 'lg:tw-text-left')}>
            <h2
              className={clsx(
                'tw-text-2xl',
                'tw-leading-tight',
                'tw-font-bold',
                'tw-text-gray-900',
                'tw-mb-10',
                'lg:tw-text-3xl'
              )}
            >
              A Tool Built for Your Business Growth
            </h2>
            <p className={clsx('tw-text-gray-700', 'tw-leading-relaxed')}>
              The CloudCFO WebApp is designed to help growing businesses streamline their accounting
              and financial workflows. Tailored for tech-enabled start-ups, scaling SMEs, and
              international subsidiaries, it combines technology, process, and expertise into one
              easy-to-use platform. With real-time access to financial reports, and scalable
              processes, it helps you make smarter decisions, stay compliant, and manage your
              finances more efficiently—so you can focus on what matters: growing your business.
            </p>
          </div>
          {/* Desktop Image (Absolute Positioning) */}
          <div
            className={clsx(
              'tw-hidden',
              'lg:tw-block',
              'tw-absolute',
              'tw-top-1/2',
              'tw--translate-y-1/2',
              'tw-right-0',
              '-tw-mr-16',
              'tw-w-1/2',
              'tw-max-w-3xl',
              'tw-z-10'
            )}
          >
            <img
              src="images/web-app-laptop-dashboard.png"
              alt="CloudCFO WebApp Dashboard"
              className={clsx('tw-rounded-lg', 'tw-w-full', 'tw-h-auto')}
            />
          </div>
          {/* Mobile Text Image (Kept as Block) */}
          <img
            src="images/web-app-laptop-dashboard.png"
            alt="CloudCFO WebApp Description"
            className={clsx(
              'tw-block',
              'lg:tw-hidden',
              'tw-rounded-lg',
              'tw-w-full',
              'tw-h-auto',
              'tw-hidden',
              'tw-mt-8'
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default BusinessGrowthSection;
